module.exports = __webpack_public_path__ + "img/full-mag-field.95a4a097.svg";